/* eslint-disable no-console */
import { useEffect } from 'react';

export const useConsoleLogVersions = () => {
  useEffect(() => {
    console.log(`version: ${process.env.NEXT_PUBLIC_VERSION}`);
    console.log(`survey version: ${process.env.NEXT_PUBLIC_SURVEY}`);
  }, []);
};
